/* eslint-disable no-unused-vars */

import { CaptionText, H4, P1, P2, P3 } from '../../../styles/FontStyles';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { color, colors } from '../../../styles/GlobalStyles';
import { BoxBig, HubImage, Td, Tr } from '../Portfolio.styled';
import moment from 'moment';

import { useTranslation } from 'react-i18next';
import Spinner from '../../../components/common/Spinner';
import { activateMyHubsFuturaMining } from '../Portfolio.actions';
import { useDispatch } from 'react-redux';
import { formatUSDNoDecimals } from '../../../helpers/helperFunctions';

export const FutureMiningItem = ({
  item,
  isAllActive
}: {
  item: any;
  isAllActive?: boolean;
}) => {
  const { t } = useTranslation('my_hubs');

  const dispatch = useDispatch();

  const returnFractions = (limit: number) => {
    switch (limit) {
      case 1200:
        return 4;
      case 2400:
        return 8;
      case 6000:
        return 20;
      case 600:
        return 2;

      default:
        break;
    }
  };

  return (
    <BoxBig relative>
      <HubImage image={item?.imageUrl}>
        <H4 color={color.colors.neutral0}>{item.product?.name}</H4>
      </HubImage>
      <Flexed column between>
        <Flexed>
          <div
            style={{
              position: 'absolute',
              left: '50%',
              right: '50%',
              transform: 'translate(-50%, -50%)'
            }}>
            <Spinner />
          </div>
          <Tr style={{ cursor: 'pointer' }}>
            {/* <Td w='20%' wSM='50%'>
              <P1 caps bold color={color.colors.primary900} mb='10'>
                COMING SOON
              </P1>
            </Td> */}
            <Td w='20%' wSM='50%'>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                ORDER ID
              </CaptionText>
              <P1 bold flex alignEnd gap='5px'>
                {item?.id}
              </P1>
            </Td>

            <Td w='20%' wSM='50%'>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                {t('date_of_purchase')}
              </CaptionText>
              <P1 bold>{moment(item?.datePaid).format('DD MMMM YYYY')}</P1>
            </Td>
          </Tr>
        </Flexed>
        <Flexed between rowSM>
          {item?.limit === null ? (
            <P2 mr='5' bold color={colors.primary900} mbSM='10'>
              Hardware: Unlimited USDT/USDC
            </P2>
          ) : (
            <Flexed column>
              <P2 mr='5' bold color={colors.primary900} mbSM='10'>
                Hardware: Max Fractions - {returnFractions(item?.limit)}
              </P2>
              <P2 mr='5' bold color={colors.primary900} mbSM='10'>
                (Up to {formatUSDNoDecimals(item?.limit)} USDT/USDC)
              </P2>
            </Flexed>
          )}
          {!isAllActive ? (
            <Button
              w='150px'
              h='40px'
              onClick={() => dispatch(activateMyHubsFuturaMining())}>
              Activate
            </Button>
          ) : item?.isActive ? (
            <></>
          ) : (
            <Button
              w='150px'
              h='40px'
              onClick={() => dispatch(activateMyHubsFuturaMining())}>
              Upgrade
            </Button>
          )}
        </Flexed>
      </Flexed>
    </BoxBig>
  );
};
